import { render, staticRenderFns } from "./normal-drawer.vue?vue&type=template&id=5d6844fe&scoped=true"
import script from "./normal-drawer.vue?vue&type=script&lang=js"
export * from "./normal-drawer.vue?vue&type=script&lang=js"
import style0 from "./normal-drawer.vue?vue&type=style&index=0&id=5d6844fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6844fe",
  null
  
)

export default component.exports